import { config } from "@jetblue/dotcom-config/dotcom";

export const ODB_KEYS = () => ["odb"] as const;
export const OD_API_BASE_URL = "https://azrest.jetblue.com/od/od-service";
export class ApiOdbError extends Error {
  public constructor(
    message: string,
    readonly statusCode: number,
  ) {
    super(message);
    this.name = "ApiOdbError";
  }
}
export type ApiResponse<T> = {
  data: T;
};
export type BaseAirport = {
  name: string;
  code: string;
  needle: string;
  jb: boolean;
  pm?: string;
  cc?: string[];
  countryCode?: string;
};
export type Region = Omit<BaseAirport, "cc"> & { cc: string[] };
export type Country = {
  code: string;
  region: string[];
  name: string;
  airports: string[];
  countrycode3: string;
};
export type CountryWithAirports<T = BaseAirport> = Omit<Country, "airports"> & {
  airports: T[];
};
export const canary = "NYC";
export type NextFetchInit = RequestInit & {
  next?: {
    revalidate?: number | false;
    tags?: readonly string[];
  };
};

const isApiOdbError = (error: unknown): error is ApiOdbError =>
  error instanceof ApiOdbError;

export const getApiOdbErrorStatusCode = (error: unknown): number | undefined =>
  isApiOdbError(error) ? error.statusCode : undefined;
export const getOriginDestinationBaseUrl = async () => {
  try {
    const { API_BASE_URLS } = await config();
    return API_BASE_URLS?.ORIGIN_DESTINATION ?? OD_API_BASE_URL;
  } catch {
    return OD_API_BASE_URL;
  }
};
